import React from "react";

const tone = (pct) => (pct === null || pct === undefined ? "none" : pct >= 80 ? "ok" : pct >= 50 ? "warn" : "crit");

/** Conic-gradient score ring. size in px. */
export default function ScoreRing({ percent, size = 96, label, testId }) {
  const t = tone(percent);
  const value = percent ?? 0;
  return (
    <div className={`cis-ring ${t}`} style={{ "--size": `${size}px`, "--pct": `${value}%` }} data-testid={testId} role="img" aria-label={`${percent === null || percent === undefined ? "No score" : `${percent}% compliant`}`}>
      <div className="cis-ring-inner">
        <b className="mono">{percent === null || percent === undefined ? "–" : `${percent}%`}</b>
        {label && <small>{label}</small>}
      </div>
    </div>
  );
}
